import useMutationCall from "../../../hooks/useMutationCall";
import { useAddOrganizationMutation } from "../organizationsSlice";

const useAddOrganization = () => {
  return useMutationCall(useAddOrganizationMutation);
};

export default useAddOrganization;
